import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _extends from "@babel/runtime/helpers/esm/extends";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Select, { components } from 'react-select';
import { IconMenuDown, IconMenuUp, IconFilterMenuDown, IconFilterMenuUp } from '@sfx/icons';
import { SearchInput } from '../Input';
import SelectAllCheck from './SelectAllCheck';
import { getTransFunc } from '../SFxLocalization';

import { get } from 'lodash';
import { SelectOption } from './type';
var prefix = 'sfx-react-ui';
var keyCodes = {
  esc: 27,
  space: 32,
  enter: 13,
  tab: 9,
  up: 38,
  down: 40,
  home: 36,
  end: 35,
  n: 78,
  p: 80
};

var stopPop = function stopPop(e) {
  e.stopPropagation();
};

var Menu = function Menu(props) {
  var children = props.children,
      selectProps = props.selectProps;
  var isMulti = selectProps.isMulti;
  var transFunc = selectProps.transFunc;
  return /*#__PURE__*/React.createElement(components.Menu, props, /*#__PURE__*/React.createElement(React.Fragment, null, selectProps.allOptions && selectProps.allOptions.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, !selectProps.isSearchDisabled && selectProps.allOptions.length > 5 && /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix, "-input-container")
  }, /*#__PURE__*/React.createElement(SearchInput, {
    placeholder: selectProps.searchPlaceholder || 'Search',
    value: selectProps.searchText,
    onChange: selectProps.setSearchText,
    onMouseDown: stopPop,
    onTouchEnd: stopPop
  })), isMulti && /*#__PURE__*/React.createElement(SelectAllCheck, {
    options: selectProps.options,
    allOptions: selectProps.allOptions,
    value: selectProps.value,
    searchText: selectProps.searchText,
    onChange: selectProps.onChange,
    transFunc: transFunc
  }), (!selectProps.isSearchDisabled && selectProps.allOptions.length > 5 || isMulti) && /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix, "-cutting-line")
  })), children));
};

var MultiValueLabel = function MultiValueLabel() {
  return null;
};

var Option = function Option(props) {
  return /*#__PURE__*/React.createElement(components.Option, props, props.isMulti && /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    className: "".concat(prefix, "-select-option-chk"),
    checked: props.isSelected,
    readOnly: true
  }), /*#__PURE__*/React.createElement("label", null), /*#__PURE__*/React.createElement("label", {
    className: "".concat(prefix, "-select-option"),
    title: props.transKey ? props.selectProps.transFunc(props.transKey) : props.label
  }, props.transKey ? props.selectProps.transFunc(props.transKey) : props.label));
};

var ValueContainer = function ValueContainer(props) {
  var transFunc = props.selectProps.transFunc;
  var selectValue = props.getValue() || [];
  var selectedCount = selectValue.length;
  var preValueText = props.selectProps.preValueText || '';

  var getOptionLabel = function (i) {
    return transFunc(i.transKey) || i.label;
  } || props.selectProps.getOptionLabel;

  if (preValueText && selectedCount > 0) {
    preValueText = preValueText + ':';
  }

  var text = selectValue.map(getOptionLabel).join(', ');
  var dom = props.isMulti ? /*#__PURE__*/React.createElement(components.ValueContainer, props, /*#__PURE__*/React.createElement("span", {
    className: "".concat(prefix, "-multi-text"),
    title: text
  }, /*#__PURE__*/React.createElement("span", {
    className: "".concat(prefix, "-multi-text-ellipsis")
  }, /*#__PURE__*/React.createElement("span", {
    className: "".concat(prefix, "-multi-pretext")
  }, preValueText), /*#__PURE__*/React.createElement("span", {
    className: "".concat(prefix, "-multi-opts")
  }, text)), props.children)) : /*#__PURE__*/React.createElement(components.ValueContainer, props, /*#__PURE__*/React.createElement("span", {
    className: "".concat(prefix, "-multi-text"),
    title: text
  }, /*#__PURE__*/React.createElement("span", {
    className: "".concat(prefix, "-multi-text-ellipsis")
  }, /*#__PURE__*/React.createElement("span", {
    className: "".concat(prefix, "-multi-pretext")
  }, preValueText), /*#__PURE__*/React.createElement("span", {
    className: "".concat(prefix, "-multi-opts")
  }, props.children))));
  return dom;
};

var DropdownIndicator = function DropdownIndicator(props) {
  var selectedCount = get(props, 'selectProps.value.length', 0);
  var isOpen = props.selectProps.menuIsOpen;
  var useFilterIcon = props.selectProps.useFilterIcon;
  var isDisabled = props.selectProps.isDisabled; // Disabled

  if (isDisabled) {
    return /*#__PURE__*/React.createElement("div", {
      className: "dropdown-indicator"
    }, /*#__PURE__*/React.createElement(IconMenuDown, {
      size: "24"
    }));
  } // No useFilterIcon select
  else if (!useFilterIcon) {
      if (isOpen) {
        return /*#__PURE__*/React.createElement("div", {
          className: "dropdown-indicator"
        }, /*#__PURE__*/React.createElement(IconMenuUp, {
          size: "24"
        }));
      }
    } // useFilterIcon select
    else if (selectedCount === 0 && isOpen) {
        return /*#__PURE__*/React.createElement("div", {
          className: "dropdown-indicator"
        }, /*#__PURE__*/React.createElement(IconMenuUp, {
          size: "24"
        }));
      } else if (selectedCount > 0 && !isOpen) {
        return /*#__PURE__*/React.createElement("div", {
          className: "filter-indicator"
        }, /*#__PURE__*/React.createElement(IconFilterMenuDown, {
          size: "20"
        }));
      } else if (selectedCount > 0 && isOpen) {
        return /*#__PURE__*/React.createElement("div", {
          className: "filter-indicator"
        }, /*#__PURE__*/React.createElement(IconFilterMenuUp, {
          size: "20"
        }));
      }

  return /*#__PURE__*/React.createElement("div", {
    className: "dropdown-indicator"
  }, /*#__PURE__*/React.createElement(IconMenuDown, {
    size: "24"
  }));
};

var Control = function Control(props) {
  var children = props.children,
      cx = props.cx,
      className = props.className,
      isDisabled = props.isDisabled,
      isFocused = props.isFocused,
      innerRef = props.innerRef,
      innerProps = props.innerProps,
      menuIsOpen = props.menuIsOpen;
  var onControlClick = props.selectProps.onControlClick;
  return /*#__PURE__*/React.createElement("div", _extends({
    onClick: onControlClick,
    ref: innerRef,
    className: cx({
      control: true,
      'control--is-disabled': isDisabled,
      'control--is-focused': isFocused,
      'control--menu-is-open': menuIsOpen
    }, className)
  }, innerProps), children);
};

var CommonSelect = /*#__PURE__*/function (_Component) {
  _inherits(CommonSelect, _Component);

  var _super = _createSuper(CommonSelect);

  function CommonSelect(props) {
    var _this;

    _classCallCheck(this, CommonSelect);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "transFunc", void 0);

    _defineProperty(_assertThisInitialized(_this), "_$container", void 0);

    _defineProperty(_assertThisInitialized(_this), "handleDocumentEvents", function (e) {
      if (!e) {
        return;
      }

      if (e.type === 'keyup') {
        if (e.which === keyCodes.esc) {
          _this.state.isOpen && _this.close();
        }
      } else {
        var container = _this.getContainer();

        if (e.target instanceof Node && !container.contains(e.target)) {
          _this.state.isOpen && _this.close();
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "toggle", function () {
      if (!_this.props.isDisabled) {
        _this.setState({
          isOpen: !_this.state.isOpen
        }, function () {
          if (_this.state.isOpen === false) {
            _this.props.onMenuClose && _this.props.onMenuClose();
          }
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "setSearchText", function (e) {
      var value = e.target.value;
      var type = e.type;
      value = value && String(value);

      if (type === 'change' && _this.state.allOptions && _this.state.allOptions.length > 0) {
        var filteredOptions = _this.state.allOptions.filter(function (x) {
          return _this.filterOptions(x, value);
        });

        _this.setState({
          searchText: value,
          options: filteredOptions
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "filterOptions", function (option, searchText) {
      if (option.filterField) {
        return option.filterField.toLowerCase().indexOf(searchText.toLowerCase()) > -1;
      } else if (typeof option.label === "string") {
        if (option.transKey) {
          return _this.transFunc(option.transKey).toLowerCase().indexOf(searchText.toLowerCase()) > -1;
        } else {
          return option.label.toLowerCase().indexOf(searchText.toLowerCase()) > -1;
        }
      } else {
        return Object.values(option).filter(function (v) {
          return typeof v === "string" && v.toLowerCase().indexOf(searchText.toLowerCase()) > -1;
        }).length > 0;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "loadOptions", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var loadedOptions, allOptions, options;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (_this.props.loadOptions) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return", null);

            case 2:
              _this.setState({
                isLoading: true
              });

              _context.next = 5;
              return _this.props.loadOptions();

            case 5:
              loadedOptions = _context.sent;
              allOptions = _this.formatDataForOption(loadedOptions, _this.props.renderOption);
              options = allOptions;

              if (allOptions && allOptions.length > 0 && _this.state.searchText && _this.state.searchText.length > 0) {
                options = _this.state.allOptions.filter(function (x) {
                  return _this.filterOptions(x, _this.state.searchText);
                });
              }

              _this.setState({
                options: options,
                allOptions: allOptions,
                isLoading: false,
                isCached: true
              });

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "onMenuOpen", function () {
      // load options if not using cache or not cached
      if (_this.props.loadOptions && (!_this.props.cacheOptions || !_this.state.isCached)) {
        _this.loadOptions();
      }

      _this.props.onMenuOpen && _this.props.onMenuOpen();
    });

    _defineProperty(_assertThisInitialized(_this), "onChange", function () {
      var _this$props;

      var isMulti = _this.props.isMulti;

      if (!isMulti) {
        _this.close();
      }

      _this.props.onChange && (_this$props = _this.props).onChange.apply(_this$props, arguments);
    });

    _defineProperty(_assertThisInitialized(_this), "formatDataForOption", function (data, renderOption) {
      var options = data;

      if (Array.isArray(options)) {
        if (renderOption) {
          options = options.map(function (i) {
            return _objectSpread(_objectSpread({}, i), renderOption(i));
          });
        }

        if (!options.every(function (opt) {
          return opt.label && opt.value;
        })) {
          console.warn("Some options of Select component don't have required properties 'label' or 'value'.");
        }
      } else if (options) {
        if (renderOption) {
          options = _objectSpread(_objectSpread({}, options), renderOption(options));
        }

        if (options["label"] == null || options["value"] == null) {
          console.warn("Value or defaultValue of a single Select component doesn't have required properties 'label' or 'value'.");
        }
      } else {
        options = [];
      }

      return options;
    });

    _defineProperty(_assertThisInitialized(_this), "formatSelectVal", function (arrName, arrValue, formattedOptions) {
      var renderOption = _this.props.renderOption;

      var formatValue = _this.formatDataForOption(arrValue, renderOption);

      var returnValue;

      if (Array.isArray(formatValue)) {
        returnValue = formatValue.map(function (v) {
          return formattedOptions.find(function (i) {
            return String(i.value) === String(v.value);
          }) || v;
        });
      } else {
        returnValue = formattedOptions.find(function (i) {
          return String(i.value) === String(formatValue.value);
        }) || formatValue;

        if (formatValue.value == undefined) {
          returnValue = undefined;
        }
      }

      return _defineProperty({}, arrName, returnValue);
    });

    _defineProperty(_assertThisInitialized(_this), "getFlagIconStyle", function () {
      var dot = function dot(FlagUrl) {
        return {
          alignItems: 'center',
          display: 'flex',
          ':before': {
            background: " url(".concat(FlagUrl, ") no-repeat 0 4px"),
            content: '" "',
            display: 'inline-block',
            marginRight: 8,
            height: 20,
            width: 20
          }
        };
      }; // FlagUrl is the keyword name


      return {
        option: function option(provided, _ref3) {
          var data = _ref3.data;
          return _objectSpread(_objectSpread({}, provided), dot(data.FlagUrl));
        },
        singleValue: function singleValue(provided, _ref4) {
          var data = _ref4.data;
          return _objectSpread(_objectSpread({}, provided), dot(data.FlagUrl));
        }
      };
    });

    var _options = _this.formatDataForOption(props.options || [], props.renderOption);

    _this.state = {
      isOpen: props.menuIsOpen,
      searchText: '',
      isLoading: false,
      isCached: false,
      options: _options,
      allOptions: _options
    };
    _this.transFunc = getTransFunc(props.transInstance);
    return _this;
  }

  _createClass(CommonSelect, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.addEvents();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeEvents();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      if (prevProps.options !== this.props.options && JSON.stringify(prevProps.options) !== JSON.stringify(this.props.options)) {
        var allOptions = this.formatDataForOption(this.props.options, this.props.renderOption);
        var options = allOptions;

        if (allOptions && allOptions.length > 0 && this.state.searchText && this.state.searchText.length > 0) {
          options = this.state.allOptions.filter(function (x) {
            return _this2.filterOptions(x, _this2.state.searchText);
          });
        }

        this.setState({
          options: options,
          allOptions: allOptions
        });
      }

      if (prevProps.menuIsOpen !== this.props.menuIsOpen) {
        this.setState({
          isOpen: this.props.menuIsOpen
        });
      }
    }
  }, {
    key: "addEvents",
    value: function addEvents() {
      var _this3 = this;

      ['click', 'touchstart', 'keyup'].forEach(function (event) {
        return document.addEventListener(event, _this3.handleDocumentEvents, true);
      });
    }
  }, {
    key: "removeEvents",
    value: function removeEvents() {
      var _this4 = this;

      ['click', 'touchstart', 'keyup'].forEach(function (event) {
        return document.removeEventListener(event, _this4.handleDocumentEvents, true);
      });
    }
  }, {
    key: "getContainer",
    value: function getContainer() {
      if (this._$container) return this._$container; // eslint-disable-next-line react/no-find-dom-node

      this._$container = ReactDOM.findDOMNode(this); // eslint-disable-next-line react/no-find-dom-node

      return ReactDOM.findDOMNode(this);
    }
  }, {
    key: "close",
    value: function close() {
      this.setState({
        isOpen: false
      });
      this.props.onMenuClose && this.props.onMenuClose();
    }
  }, {
    key: "render",
    value: function render() {
      var showFlag = this.props.showFlag;
      var _this$props2 = this.props,
          value = _this$props2.value,
          defaultValue = _this$props2.defaultValue,
          isMulti = _this$props2.isMulti;
      var valueProps = value && this.formatSelectVal('value', value, this.state.allOptions);
      var defaultValueProps = defaultValue && this.formatSelectVal('defaultValue', defaultValue, this.state.allOptions);
      var defaultSettingProps = {
        closeMenuOnSelect: !isMulti,
        isClearable: false,
        backspaceRemovesValue: false,
        hideSelectedOptions: false
      };

      var props = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, defaultSettingProps), this.props), valueProps), defaultValueProps);

      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Select, _extends({}, props, {
        onMenuOpen: this.onMenuOpen,
        onMenuClose: undefined // Call onMenuClose with in this wrapper component
        ,
        placeholder: this.props.preValueText ? '' : this.props.placeholder,
        isSearchable: false // Disable default search
        ,
        setSearchText: this.setSearchText,
        searchText: this.state.searchText,
        isSearchDisabled: this.props.isSearchDisabled,
        classNamePrefix: "".concat(prefix),
        className: "".concat(prefix, "-select"),
        styles: showFlag ? this.getFlagIconStyle() : undefined,
        theme: function theme(_theme) {
          return _objectSpread(_objectSpread({}, _theme), {}, {
            borderRadius: 0,
            boxShadow: 'none',
            colors: {}
          });
        },
        components: _objectSpread({
          Menu: Menu,
          DropdownIndicator: DropdownIndicator,
          Option: Option,
          MultiValueLabel: MultiValueLabel,
          ValueContainer: ValueContainer,
          Control: Control
        }, this.props.components),
        options: this.state.options,
        allOptions: this.state.allOptions,
        menuIsOpen: this.state.isOpen,
        onControlClick: this.toggle,
        onChange: this.onChange,
        isLoading: this.props.isLoading || this.state.isLoading,
        transFunc: this.transFunc
      })));
    }
  }]);

  return CommonSelect;
}(Component);

_defineProperty(CommonSelect, "defaultProps", {
  showFlag: false,
  menuIsOpen: false
});

export default CommonSelect;
export { components as SelectComponents, Control, SelectOption };